import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import EmptyHeartIcon from '../../assets/icon-heart-outline.svg?react';
import InfoIcon from '../../assets/icon-info.svg?react';
import ArrowDownwardsIcon from '../../assets/icon-cheveron.svg?react';
import RateAppIcon from '@/assets/icon-rate-app.svg?react';
import { SummaryModal } from '../../components/library/components/modals/SummaryModal';
import { aiAppsConfig } from '../../components/library/configs/aiApps.config';
import { getAiApp, toggleAppFavoriteStatus } from '@/services/aiApps';
import useElysiaStore from '@/app/elysia-store';
import RatingAppModal from './RatingAppModal';
import NewChatIcon from '../../assets/icon-topic.svg?react';

const AppActionsDropdown = ({ aiAppId, startNewTopicChat }) => {
  const [open, setOpen] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [singleCardData, setSingleCardData] = useState<any>(null);
  const setAppFavourite = useElysiaStore((state) => state.setAppFavourite);
  const favoriteList = useElysiaStore((state) => state.favouriteAgent);
  const isChatDisabled = useElysiaStore((state) => state.isChatDisabled);
  const [markFavourite, setMarkFavourite] = useState(false);
  const [showAppRateModal, setShowAppRateModal] = useState(false);

  useEffect(() => {
    const favItem = favoriteList?.find((ele) => ele.agent_id === singleCardData?.agent_id);
    setMarkFavourite(favItem?.is_favourite ?? false);
  }, [favoriteList, singleCardData?.agent_id]);

  useEffect(
    () => {
      const getAppData = async () => {
        const app = await getAiApp(aiAppId);
        setSingleCardData(app);
      };
      getAppData();
    },
    //eslint-disable-next-line
    []
  );
  const handleToggleFavourite = async () => {
    const payload = { agent_id: aiAppId, is_favourite: !markFavourite };
    const response = await toggleAppFavoriteStatus(payload);
    if (response?.data?.status) {
      setAppFavourite(payload);
    }
    setMarkFavourite(!markFavourite);
  };

  const isDisabled =
    singleCardData?.agent_status === 'unpublished' || singleCardData?.agent_status === 'read-only';
  return (
    <div>
      <div className="app-action-item">
        <Dropdown show={open} autoClose="outside" onToggle={(isOpen) => setOpen(isOpen)}>
          <Dropdown.Toggle
            as="button"
            className="ms-1 mb-0 mt-0 p-0 h-auto cursor-pointer dropdown-toggle-no-caret bg-transparent"
            aria-label="App-action-dropdown"
          >
            <ArrowDownwardsIcon className="arrow-icon" />
          </Dropdown.Toggle>

          <Dropdown.Menu align="end" className="action-menu mt-2">
            <Dropdown.Item
              onClick={() => startNewTopicChat(false)}
              className="w-100 item mb-1"
              disabled={isChatDisabled || isDisabled}
            >
              <span
                className={`me-2 info-icon ${isChatDisabled || isDisabled ? 'opacity-50' : ''}`}
              >
                <NewChatIcon />
              </span>
              Start New Chat
            </Dropdown.Item>
            <Dropdown.Item
              onClick={handleToggleFavourite}
              className="w-100 item"
              disabled={isDisabled}
            >
              <span className={`me-2 info-icon ${isDisabled ? 'opacity-50' : ''}`}>
                <EmptyHeartIcon />
              </span>
              {markFavourite ? 'Remove from Favourites' : 'Add to Favourites'}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => setShowAppRateModal(true)}
              className="w-100 item"
              disabled={isDisabled}
            >
              <span className={`me-2 info-icon ${isDisabled ? 'opacity-50' : ''}`}>
                <RateAppIcon />
              </span>
              Rate App
            </Dropdown.Item>
            <Dropdown.Item
              disabled={singleCardData?.agent_status === 'read-only'}
              onClick={() => setShowSummaryModal(true)}
              className={`w-100 item`}
            >
              <span
                className={`me-2 info-icon ${singleCardData?.agent_status === 'read-only' ? 'opacity-50' : ''}`}
              >
                <InfoIcon />
              </span>
              View App Info
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {showSummaryModal && (
        <SummaryModal
          config={aiAppsConfig}
          cardData={singleCardData}
          showModal={showSummaryModal}
          setShowSummaryModal={setShowSummaryModal}
          tabName="in-app"
        />
      )}
      {showAppRateModal && (
        <RatingAppModal
          setShowAppRateModal={setShowAppRateModal}
          showModal={showAppRateModal}
          singleAppData={singleCardData}
          setSingleCardData={setSingleCardData}
        />
      )}
    </div>
  );
};

export default AppActionsDropdown;
